/* oxlint-disable perfectionist/sort-imports */
import "@/platform/utils/sentry";

import { initArgus } from "@solvari/argus/service";
import { initAbTesting } from "@solvari/ab-testing";
import { initCookiePopup, initHeyflowForm } from "@solvari/components";

import "@/platform/layouts/default/default.css";
import "@/platform/components/header/header";
import "@solvari/components/blade/review/review-widget/reviewScore.css";
import "@solvari/components/blade/pro/s-company-badges/sCompanyBadge.css";
import "@/platform/components/s-visited-pages/sVisitedPages";
import "@/platform/components/footer/footer";
import { initPlatformVueIslands } from "@/platform/vueIslands";
import { initFontAwesome } from "@solvari/common-fe/integrations";
import { initReviews } from "@solvari/components/blade/review/reviews.ts";
import "@solvari/components/blade/product/productIcon.css";
import "@/views/client/jobs/partials/core-values/coreValues.css";
import {
  addMarketingParamsGtmEvent,
  initInteractionTracking,
} from "@solvari/argus";
import { getEnv } from "@solvari/utils";
import { localeToIso } from "@solvari/translations";
import { startUserDataGtmWatcher } from "@solvari/common-fe/composables";

/* oxlint-enable perfectionist/sort-imports */

async function main() {
  const argusSession = initArgus();
  void addMarketingParamsGtmEvent();
  initInteractionTracking();
  initCookiePopup();
  initFontAwesome();
  initReviews();

  await initAbTesting(argusSession.clientId, {
    siteLocale: localeToIso(getEnv().config.localeCode),
    siteType: "platform",
  });
  initPlatformVueIslands();

  startUserDataGtmWatcher();

  void initHeyflowForm();
}

void main();
